import { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';
import * as dayjs from 'dayjs'

const PROG = 'ChartCollectorCardStampsPerDay.js';

const ChartCollectorCardStampsPerDay = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    loadChartData();
  }, [props.timeRange]);

  const loadChartData = async () => {
    const FUNCTION = 'loadChartData';

    try {
      setIsLoadingData(true);
      const _chartDataResponse = await apiComms.getChartDataStampsPerDayByCollectorCard(props.timeRange);
      if (_chartDataResponse && !_chartDataResponse.isErr) {
        const _chartData = _chartDataResponse.response.chartdata;
        const _chartDataDateParsed = _parseChartDataDates(_chartData);
        setChartData(_chartDataDateParsed);
      }
      setIsLoadingData(false);
    }
    catch (e) {
      logger.error('Exception Occured', { PROG, FUNCTION });
      console.log('Exception: '+e+', '+e.stack);
    }
  };

  const _parseChartDataDates = (_chartData) => {
    let _parsedChartData = [];
    _chartData.forEach((_chartDataRec) => {
      const _chartDateEpoch = (_chartDataRec.x*1000);
      const _chartDateDayJs = dayjs(_chartDateEpoch);
      const _chartDateReadable = _chartDateDayJs.format('DD/MMM/YYYY');
      _parsedChartData.push({
        date : _chartDateReadable,
        nadur2 : _chartDataRec.nadur2,
        nadur6 : _chartDataRec.nadur6,
        nadur12 : _chartDataRec.nadur12
      });
    });

    return _parsedChartData;
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 280 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <LineChart
                data={chartData}
                margin={{ top: 20, right: 20, left: 6, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  angle={45}
                  textAnchor="start"
                  height={60}
                  tick={{ fontSize: 10 }}
                />
                <YAxis width={42} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="nadur2" stroke="#369fe3" strokeWidth={2} dot={false} name="NADUR-2" />
                <Line type="monotone" dataKey="nadur6" stroke="#20c997" strokeWidth={2} dot={false} name="NADUR-6" />
                <Line type="monotone" dataKey="nadur12" stroke="#f59f00" strokeWidth={2} dot={false} name="NADUR-12" />
              </LineChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Stamps Collected Per Day By Collector Card
        </div>
      </div>
    </div>
  );
};

export default ChartCollectorCardStampsPerDay;
